import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from 'src/routes/PrivateRoute';
import PublicRoute from 'src/routes/PublicRoute';
import { AccessDeniedPage, ForgotPasswordPage, LoginPage, SetPasswordPage } from '../pages';

export const routes = (
  <>
    <Route
      path="/login"
      element={
        <PublicRoute>
          <LoginPage />
        </PublicRoute>
      }
    />
    <Route
      path="/forgot-password"
      element={
        <PublicRoute>
          <ForgotPasswordPage />
        </PublicRoute>
      }
    />
    <Route
      path="/set-password"
      element={
        <PublicRoute>
          <SetPasswordPage />
        </PublicRoute>
      }
    />
    <Route
      path="/access-denied"
      element={
        <PrivateRoute>
          <AccessDeniedPage />
        </PrivateRoute>
      }
    />
  </>
);
